import React, {Component} from 'react';
import {Container, Card, CardHeader, CardBody, CardFooter, Breadcrumb, BreadcrumbItem} from 'reactstrap';
import axios from 'axios';
import Cookies from 'universal-cookie'

const cookies = new Cookies();
const qs = require('qs');
const prebase = window.location.protocol + '//' + window.location.host;
const base = (prebase.indexOf('3000') > -1) ? prebase.replace('3000', '8080') : prebase;

export default class HistoryList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pid: props.match.params.pid,
            historys: [],
        };
        this.loadPatient();
    }

    loadPatient() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/patients/patient/${this.state.pid}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                patient: response.data[0],
            }, this.loadHistorys);
        }).catch(error => {
            console.log(error);
        })
    }
    
    loadHistorys() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/patients/history/${this.state.pid}/list/`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                historys: response.data,
            })
        }).catch(error => {
            console.log(error);
        })
    }

    render() {
        let patient = this.state.patient ? this.state.patient.fields : {};
        return (
            <Container>
                <Card>
                    <CardHeader>
                        <h2 className="float-left">Patient History</h2>
                        <a className="mui-btn mui-btn--raised float-right" href={"/admin/history?" + qs.stringify({pid: this.state.pid, then: `/admin/patients/${this.state.pid}/screening/list`})}>Update History</a>
                    </CardHeader>
                    <CardBody>
                        {this.state.historys.map((history) => (
                            <a key={history.pk} href={`/admin/patients/${this.state.pid}/history/${history.pk}`}>
                                <Card key={history.pk}> 
                                    <CardBody>
                                    <p className="h4 float-left">{patient.LastName + ', ' + patient.FirstName}</p>
                                    <p className="h5 float-right">{history.fields.updated}</p>
                                    </CardBody>
                                </Card>
                            </a>
                        ))}
                    </CardBody>
                    <CardFooter>
                    </CardFooter>
                </Card>
            </Container>
        )
    }
}
